class LpSlackRefs {
  constructor() {
    this.saveSlack = [];
    this.sendinblue = [];
    this.mixpanel = [];
  }

  initSlackRef(slkRef) {
    if (slkRef && slkRef.length > 0) {
      // this.saveSlack = slkRef.map((idx) => {
      //     if(idx.extractions.slack && idx.extractions.slack.enabled) {
      //         return {
      //             name: idx.extractions.slack.name,
      //             channel: idx.extractions.slack.channel,
      //             type: idx.type,
      //             id: idx.id
      //         }
      //     }
      // });
      // Here starting the extraction
      slkRef.forEach((idx) => {
        const { type, id } = idx;
        // Now with the sending things.
        // slack
        if (idx.extractions.slack && idx.extractions.slack.enabled) {
          this.saveSlack.push({
            name: idx.extractions.slack.name,
            channel: idx.extractions.slack.channel,
            type,
            id,
          });
        }
        if (idx.extractions.mixpanel && idx.extractions.mixpanel.enabled) {
          this.mixpanel.push({
            name: idx.extractions.mixpanel.name,
            type,
            id,
          });
        }
        if (idx.extractions.sendinblue && idx.extractions.sendinblue.enabled) {
          this.sendinblue.push({
            name: idx.extractions.sendinblue.name,
            type,
            id,
          });
        }
      }, this);
    }
  }
}

export default LpSlackRefs;



// WEBPACK FOOTER //
// ./src/app/refs/slack.js